import fr from 'facet-rest';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';

export const HouseholdSelectMetaOverrideSet = fr.metaOverride()
  .typeOverride('picklist', {
    hidden: false,
    _component: () => SearchableSelect,
  });
